module.exports = __webpack_public_path__ + "media/images/icons/chat-popup-98095c77af258f7db507e548b7f26a01.svg";